<template>
  <div class="notifications-page">

    <div class="page-header">

      <div>
        <h1>Notifications</h1>
        <p>Stay updated with reviews, referrals, campaigns, and system activity.</p>
      </div>

      <div class="header-actions">

        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input 
            v-model="search_key"
            placeholder="Search notifications..." 
          />
        </div>

        <button class="ghost-btn" @click="markAllRead">
          Mark All Read
        </button>

      </div>

    </div>

    <div class="notifications-list">

      <div 
        v-for="note in notifications" 
        :key="note.noti_id"
        :class="['notification-card', { unread: !note.read }]"
      >

        <div class="note-icon review">
          <span class="material-symbols-outlined">notifications</span>
        </div>

        <div class="note-content">
          <div class="note-header">
            <strong>{{ note.noti_title }}</strong>
            <span>{{ formatTime(note.noti_datetime) }}</span>
          </div>

          <p>{{ note.noti_desc }}</p>
        </div>

        <!-- <div class="note-actions">
          <button class="mini-btn">•••</button>
        </div> -->

      </div>

    </div>

  </div>
</template>
<script>
import { getNotiList } from "@/apis/userapis";

export default {
  name: "NotificationsListScreen",

  data() {
    return {
      notifications: [],
      search_key: "",
      page: 0,
      noti_to: ""
    };
  },

  mounted() {
    const tmp = sessionStorage.getItem("ldata") || "";
    
    if (tmp && tmp.length > 0) {
        const ldata = JSON.parse(tmp);
      
      if (ldata) {
        this.noti_to = ldata.user_id;
        this.loadNotifications();
      }
    }
  },

  watch: {
    search_key() {
      this.page = 0;
      this.loadNotifications();
    }
  },

  methods: {

    async loadNotifications() {
      const res = await getNotiList(
        this.noti_to,
        this.search_key,
        this.page
      );

      if (res.status) {

        this.notifications = res.data.map(n => ({
          ...n,
          read: true // backend has no read flag
        }));

      }
    },

    markAllRead() {
      this.notifications = this.notifications.map(n => ({
        ...n,
        read: true
      }));
    },

    formatTime(datetime) {
      if (!datetime) return "";
      return new Date(datetime).toLocaleString();
    }

  }
};
</script>
<style scoped>
.notifications-page {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #f6f7f8;
  min-height: 100vh;
}

/* HEADER */
.page-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.page-header h1 {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
}

.page-header p {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

/* SEARCH */
.search-box {
  height: 40px;
  background: white;
  border-radius: 10px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  min-width: 240px;
}

.search-box span {
  font-size: 18px;
  color: #94a3b8;
}

.search-box input {
  border: none;
  outline: none;
  font-size: 13px;
  width: 100%;
}

/* FILTER BTN */
.filter-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* BUTTONS */
.primary-btn {
  height: 40px;
  padding: 0 16px;
  background: #197fe6;
  border-radius: 10px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  border: none;
}

.ghost-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
}

/* LIST */
.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* CARD */
.notification-card {
  background: white;
  border-radius: 16px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  display: flex;
  gap: 12px;
  align-items: center;
  transition: 0.2s;
}

.notification-card:hover {
  background: #f8fafc;
}

.notification-card.unread {
  border-color: #197fe6;
  background: rgba(25,127,230,0.03);
}

/* ICON */
.note-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.note-icon.review {
  background: #eff6ff;
  color: #197fe6;
}

.note-icon.referral {
  background: #dcfce7;
  color: #16a34a;
}

.note-icon.campaign {
  background: #fef9c3;
  color: #854d0e;
}

.note-icon.warning {
  background: #fee2e2;
  color: #dc2626;
}

/* CONTENT */
.note-content {
  flex: 1;
}

.note-header {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.note-header span {
  font-size: 11px;
  color: #94a3b8;
}

.note-content p {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}

/* MINI BTN */
.mini-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
}

/* MOBILE */
@media(max-width:768px) {

  .notifications-page {
    padding: 16px;
  }

  .notification-card {
    align-items: flex-start;
  }

  .note-header {
    flex-direction: column;
    gap: 2px;
  }

  .search-box {
    width: 100%;
  }
}

</style>